import { API_CONFIG } from "@/shared/configs/apiConfig.js"
import Storage from '@/shared/utils/storage'

export default {
  url({ type, period, storeId }) {
    const userData = Storage.get('userData')
    // utiliser storeId si fourni, sinon utiliser companyId depuis userData
    const id = storeId || userData?.metadata?.companyId
    const periodKeys = {
      year: { key: 'month', limit: 12 },
      week: { key: 'day', limit: 7 },
      month: { key: 'day', limit: 30 },
    }
    const periodKey = periodKeys[period]
    let url = `${API_CONFIG.BASE_URLS.PAYMENT}/stats/${id}/${periodKey.key}/${periodKey.limit}?group=${API_CONFIG.GROUP}&service=rapidoo&subType=${type}&type=orders`
    console.log("🚀 ~ url:", url)
    return url
  },

  parse(raw = {}, payload = { type: '', period: '' }) {
    // Sélection dynamique selon le type et la période

    if (!raw || raw?.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 500,
        data: { stats: null },
        currency: 'XOF',
      }
    }

    const dates = getDateRange(payload.period).map(e => e.replace(/0(\d-)/g, '$1'))
    console.log("🚀 ~ raw.data:", raw.data)
    console.log("🚀 ~ dates:", dates)
    const formattedStats = dates.map(date => {
      return (
        {
        amount: raw.data.find(el => el.periodId === date)?.amount || 0,
        count: raw.data.find(el => el.periodId === date)?.count || 0,
      }
      );
    })
    console.log("🚀 ~ formattedStats:", formattedStats)

    return {
      statusCode: 200,
      data: { stats: formattedStats },
      currency: raw.currency || 'XOF',
    }
  },
}

function getDateRange(type = 'week') {
  const today = new Date()
  const year = today.getFullYear()
  const month = today.getMonth()

  const formatDate = date =>
    date
      .toLocaleDateString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      })
      .replace(/\//g, '-')

  if (type === 'week') {
    const dayOfWeek = today.getDay()
    const monday = new Date(today)
    monday.setDate(today.getDate() - ((dayOfWeek + 6) % 7))
    return Array.from({ length: 7 }, (_, i) => {
      const d = new Date(monday)
      d.setDate(monday.getDate() + i)
      return formatDate(d)
    })
  }

  if (type === 'month') {
    const daysInMonth = new Date(year, month + 1, 0).getDate()
    return Array.from({ length: daysInMonth }, (_, i) =>
      formatDate(new Date(year, month, i + 1)),
    )
  }

  if (type === 'year') {
    return Array.from(
      { length: 12 },
      (_, i) => `${String(i + 1).padStart(2, '0')}-${year}`,
    )
  }

  throw new Error("Type inconnu. Utilise 'week', 'month' ou 'year'.")
}
